module.exports = __webpack_public_path__ + "img/captrader.bb080df.png";